class FAQs extends HTMLElement {
    constructor() {
        super();

        this.filter = document.getElementById('haloFAQsFilter');
        this.faqsPopup = document.getElementById('halo-faqs-popup');

        if(this.filter){
            this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
            this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
            this.filterDropdownArrow = this.filterToggle ? this.filterToggle.querySelector('[data-dropdown-arrow]') : null;

            if(this.filterToggle){
                this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
            }

            if(this.filterDropdown && this.filterDropdown.querySelector('.text')){
                this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
                    filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
                });
            }
        }

        if(this.querySelector('.faqs')){
            this.querySelectorAll('.card-header').forEach((headerButton) => {
                headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
            });
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    onClickFilterHandler(){
        if(!this.filterDropdown) return;
        if(this.filterDropdown.classList.contains('is-show')){
            this.filterDropdown.classList.remove('is-show');
            if(this.filterDropdownArrow) this.filterDropdownArrow.classList.remove('active');
        } else {
            this.filterDropdown.classList.add('is-show');
            if(this.filterDropdownArrow) this.filterDropdownArrow.classList.add('active');
        }
    }

    onClickFilterButtonHandler(event){
        var btn = event.target.closest('li');
        if(!btn) return;

        if(!btn.classList.contains('is-active')){
            var filterValue = btn.getAttribute('data-value'),
                filterText = event.target.innerText;

            if(this.filterToggle){
                var toggleText = this.filterToggle.querySelector('.text');
                if(toggleText) toggleText.innerText = filterText;
            }

            if(this.filterDropdown){
                this.filterDropdown.querySelectorAll('li').forEach((element) => {
                    element.classList.remove('is-active');
                });
            }

            btn.classList.add('is-active');

            if(filterValue !== undefined && filterValue !== null){
                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    var id = element.getAttribute('id');

                    if(id == filterValue){
                        element.classList.remove('is-hidden');
                        element.classList.add('is-active');
                    } else {
                        element.classList.remove('is-active');
                        element.classList.add('is-hidden');
                    }
                });
            } else {

                this.querySelectorAll('.faqs-paragraph').forEach((element) => {
                    element.classList.remove('is-hidden', 'is-active');
                });
            }

            if(this.filterDropdown) this.filterDropdown.classList.remove('is-show');
            if(this.filterDropdownArrow) this.filterDropdownArrow.classList.remove('active');
        }
    }

    onClickHeaderButtonHandler(event){
        const btn = event.currentTarget;
        const content = btn ? btn.nextElementSibling : null;
        if(!btn || !content) return;

        btn.classList.toggle('collapsed');

        if (content.style.maxHeight){
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    onBodyClickEvent(event) {
        if (!this.filterDropdown) return;
        if (event.target.closest('[data-faqs-filter]') != null) return;
        if(this.filterDropdown.classList.contains('is-show')) {
            this.filterDropdown.classList.remove('is-show');
            if(this.filterDropdownArrow) this.filterDropdownArrow.classList.remove('active');
        }
    }
}

customElements.define('faqs-item', FAQs);

(function() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/faq') return;

    var replacement = '<p>Please email <a href="mailto:info@pinepollen.co.nz">info@pinepollen.co.nz</a> with the following information:<br><br>1) Who you are<br>2) Your background, key skills, and experience<br>3) Your current role or organisation, or note if you are self-employed or retired<br>4) Your experience as an investor</p><p>Thanks</p>';

    function updateInvestorFaqAnswer() {
        var answer = document.getElementById('answer-paragraph_xfC8Kk-2');

        if (!answer) {
            var titles = Array.prototype.slice.call(document.querySelectorAll('.faqs-item .title'));
            var title = titles.find(function(element) {
                return element.textContent.trim() === 'Can I invest in Bio Gold?';
            });
            answer = title && title.closest('.faqs-item') ? title.closest('.faqs-item').querySelector('.card-body') : null;
        }

        if (!answer) return;

        var content = answer.querySelector('div') || answer;
        var text = content.textContent || '';
        var hasOldInvestorCopy = text.indexOf('While we are not currently accepting external investment') !== -1 ||
            text.indexOf('preferred investment amount') !== -1;

        if (hasOldInvestorCopy) content.innerHTML = replacement;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateInvestorFaqAnswer);
    } else {
        updateInvestorFaqAnswer();
    }

    window.setTimeout(updateInvestorFaqAnswer, 300);
})();
